const generateKey = () => Date.now().toString(36) + Math.random().toString(36).substring(2);

const generateId = (...ids: string[]) => ids.join('.');

export { generateId, generateKey };
